import {
  Input as SharedInput,
  type InputProps as SharedInputProps
} from '@novelaide/ui/components/Input'
import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

export type InputProps = Omit<SharedInputProps, 'inputSize'>

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <SharedInput
        type={type}
        className={cn(
          'flex w-full py-1 shadow-sm focus-visible:ring-1 focus-visible:ring-ring',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'
